import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-modal-container',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalContainerComponent implements OnInit {
    @Input() title!: string;

    constructor() {
    }

    ngOnInit(): void {
    }

}
